module.exports = __webpack_public_path__ + "img/1970East-069_WEB-min.e8c19fab.jpg";